import {
  SupplierGetResponseType,
  PriceTierOrderRuleItemType,
} from "@sellar-io/api-v2/types";
import { getDiscountDescription } from "@sellar-io/common";

type StockItemType = PriceTierOrderRuleItemType | "badge";

export function DiscountSummary({
  discounts,
  currency,
  hideInfo,
}: {
  discounts?: SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierDiscounts"];
  currency?: string;
  hideInfo?: boolean;
}) {
  return (
    <div>
      {discounts?.sort(byTypeThenQuantity).map((discount, i) => (
        <div key={i}>
          {getDiscountDescription({
            discount,
            currency,
          })}
        </div>
      ))}
      {!hideInfo && <>(Discounts automatically calculated in basket)</>}
    </div>
  );
}

const byQuantity = (a: number, b: number) => {
  return a - b;
};

const byType = (a: StockItemType | null, b: StockItemType | null) => {
  return a?.localeCompare(b ?? "");
};

const byTypeThenQuantity = (
  a: SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierDiscounts"][number],
  b: SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierDiscounts"][number],
): number => {
  const type =
    byType(a.itemType, b.itemType) || byQuantity(a.quantity, b.quantity);
  if (type >= 0) {
    return type;
  }
  return 0;
};
